export default __webpack_public_path__ + "static/media/three.d88cb1fc.png";